<template>
  <!--<div class="menu">-->
  <!--侧边栏-->
  <!-- <el-container>
    <el-aside> -->
  <div class="menu">
    <div class>
      <!--blue-->
      <div
        class="menuphoto"
        :class="{ active: sidebar_active === 'person', 'photo-div': true }"
        @click="go_person()"
      >
        <div>
          <div class="photo">
            <img :src="src" />
          </div>
        </div>
        <div class="usernametxt">
          <span v-html="user.psnName"></span>
        </div>
        <!-- <div class="title-detail">{{user.rankName}}</div> -->
      </div>
    </div>
    <div>
      <!-- <div
            class="sidebarcom sidebar1"
            :class="{ 'active': sidebar_active==='home','menu-item':true}"
            @click="go_home()"
          >
            <div class="icon"></div>
            <div class="txt">首页</div>
          </div> -->
    </div>
    <div class>
      <div
        class="sidebarcom sidebar2"
        :class="{ active: sidebar_active === 'sale', 'menu-item': true }"
        @click="go_sale($event)"
      >
        <div class="icon"></div>
        <div class="txt">销售</div>
      </div>
    </div>
    <div class v-show="showRecruit">
      <div
        class="sidebarcom sidebar10"
        :class="{ active: sidebar_active === 'recruit', 'menu-item': true }"
        @click="go_Recruit()"
      >
        <div class="icon"></div>
        <div class="txt">个险招募</div>
      </div>
    </div>
    <div class>
      <div
        class="sidebarcom sidebar3"
        :class="{ active: sidebar_active === 'team', 'menu-item': true }"
        @click="go_team()"
      >
        <div class="icon"></div>
        <div class="txt">团队</div>
      </div>
    </div>
    <div class v-show="showConsult">
      <div
        class="sidebarcom sidebar34"
        :class="{ active: sidebar_active === 'operation', 'menu-item': true }"
        @click="go_operation()"
      >
        <div class="icon"></div>
        <div class="txt">客服咨询</div>
      </div>
    </div>
    <div>
      <div
        class="sidebarcom sidebar4"
        :class="{ active: sidebar_active === 'message', 'menu-item': true }"
        @click="go_message()"
      >
        <!-- <img src = "static/image/sidebar-message.png" /> -->
        <div class="icon"></div>
        <div class="txt">资讯</div>
      </div>
    </div>
    <div class v-show="showContent">
      <div
        class="sidebarcom sidebar5"
        :class="{ active: sidebar_active === 'content', 'menu-item': true }"
        @click="go_content()"
      >
        <!-- <img src = "static/image/sidebar-message.png" /> -->
        <div class="icon"></div>
        <div class="txt">内容</div>
      </div>
    </div>
    <div class v-show="showExamManage">
      <div
        class="sidebarcom sidebar6"
        :class="{ active: sidebar_active === 'examManage', 'menu-item': true }"
        @click="go_examManage()"
      >
        <!-- <img src = "static/image/sidebar-message.png" /> -->
        <div class="icon"></div>
        <div class="txt">考试</div>
      </div>
    </div>
    <div class v-show="showExamSearch">
      <div
        class="sidebarcom sidebar6"
        :class="{ active: sidebar_active === 'examManage', 'menu-item': true }"
        @click="go_examManage2()"
      >
        <!-- <img src = "static/image/sidebar-message.png" /> -->
        <div class="icon"></div>
        <div class="txt">考试查询</div>
      </div>
    </div>
    <div class v-show="showCourseManage">
      <div
        class="sidebarcom sidebar7"
        :class="{ active: sidebar_active === 'training', 'menu-item': true }"
        @click="go_training()"
      >
        <div class="icon"></div>
        <div class="txt">培训</div>
      </div>
    </div>
    <div class v-show="showActivityManage">
      <div
        class="sidebarcom sidebar8"
        :class="{ active: sidebar_active === 'Activity', 'menu-item': true }"
        @click="go_Activity()"
      >
        <div class="icon"></div>
        <div class="txt">活动量</div>
      </div>
    </div>
    <div class v-show="showSpeaking">
      <div
        class="sidebarcom sidebar9"
        :class="{ active: sidebar_active === 'speaking', 'menu-item': true }"
        @click="go_Speaking()"
      >
        <div class="icon"></div>
        <div class="txt">创说会</div>
      </div>
    </div>
    <div
      class="saleModel"
      :class="{ 'sale-model': true, sale_hide: sale_hide }"
    >
      <el-row class="tac">
        <el-col>
          <h1>销售</h1>
          <el-collapse
            v-model="activeName"
            accordion
            v-for="(cell, idx) in saleArr"
            :key="idx"
          >
            <el-collapse-item
              :title="cell.privName"
              :name="idx"
              class="coll-item"
            >
              <el-menu class="submenu">
                <div
                  v-for="(item, index) in cell.children"
                  :key="index"
                  v-if="cell.privName.includes('续期')"
                  class="dotItem"
                >
                  <div class="itemleftq iteminline"></div>
                  <div
                    class="item iteminline"
                    @click="toURLParameter(item.url)"
                  >
                    {{ item.privName }}
                  </div>
                </div>
                <div
                  v-for="(item, index) in cell.children"
                  :key="index"
                  v-if="cell.privName.includes('预收')"
                  class="dotItem"
                >
                  <div class="itemleftq iteminline"></div>
                  <div
                    class="item iteminline"
                    @click="toURLParameter(item.url)"
                  >
                    {{ item.privName }}
                  </div>
                </div>
                <div
                  v-for="(item, index) in cell.children"
                  :key="index"
                  v-if="cell.privName.includes('荣誉体系管理')"
                  class="dotItem"
                >
                  <div class="itemleftq iteminline"></div>
                  <div
                    class="item iteminline"
                    @click="toURLParameter(item.url)"
                  >
                    {{ item.privName }}
                  </div>
                </div>
                <el-menu-item
                  v-for="(item, index) in cell.children"
                  :key="index"
                  v-if="
                    cell.privName.includes('投保') ||
                    cell.privName.includes('销售') ||
                    cell.privName.includes('保单') ||
                    cell.privName.includes('首期') ||
                    cell.privName.includes('证件有效期更新追踪') ||
                    cell.privName.includes('通用保全工作台')
                  "
                >
                  <template slot="title" class="sub"
                    ><div
                      @click="toURLParameter(item.url)"
                      style="marginleft: 18px"
                    >
                      {{ item.privName }}
                    </div></template
                  >
                </el-menu-item>
              </el-menu>
            </el-collapse-item>
          </el-collapse>
        </el-col>
      </el-row>
    </div>
    <div
      class="teamModel"
      :class="{ 'sale-model': true, team_hide: team_hide }"
    >
      <el-row class="tac">
        <el-col>
          <el-menu
            class="el-menu-vertical-demo"
            @open="handleOpen"
            @close="handleClose"
            :unique-opened="true"
          >
            <h1>团队</h1>
            <!-- <div class="teamShow">
                  <el-menu-item @click="goTeamRate">
                    团队继续率
                  </el-menu-item>
                </div> -->
            <div v-if="isLeader">
              <el-submenu index="1">
                <template slot="title">
                  <!-- <i class="el-icon-location"></i> -->
                  <span>团队信息</span>
                </template>

                <!-- 团队树-->
                <el-submenu
                  :index="teamTree.teamCode + '-' + teamTree.leadAgentNum"
                  v-if="teamCode === 'Q'"
                >
                  <el-menu-item
                    @click="
                      queryInfo(
                        teamTree.teamCode + '-' + teamTree.leadAgentNum,
                        1
                      )
                    "
                    >全部</el-menu-item
                  >
                  <span slot="title">{{ teamTree.teamName }}</span>
                  <el-submenu
                    :index="team.teamCode + '-' + team.leadAgentNum"
                    v-for="team in teamTree.teamTree"
                    :key="team.leadAgentNum"
                  >
                    <el-menu-item
                      @click="
                        queryInfo(team.teamCode + '-' + team.leadAgentNum, 1)
                      "
                      >全部</el-menu-item
                    >
                    <span slot="title">{{ team.teamName }}</span>
                    <el-menu-item
                      :index="team2.teamCode + '-' + team2.leadAgentNum"
                      v-for="team2 in team.teamTree"
                      :key="team2.leadAgentNum"
                      @click="
                        queryInfo(team2.teamCode + '-' + team2.leadAgentNum, 1)
                      "
                      >{{ team2.teamName }}</el-menu-item
                    >
                  </el-submenu>
                </el-submenu>
                <el-submenu
                  :index="teamTree.teamCode + '-' + teamTree.leadAgentNum"
                  v-if="teamCode === 'B'"
                >
                  <el-menu-item
                    @click="
                      queryInfo(
                        teamTree.teamCode + '-' + teamTree.leadAgentNum,
                        1
                      )
                    "
                    >全部</el-menu-item
                  >
                  <span slot="title">{{ teamTree.teamName }}</span>
                  <el-menu-item
                    :index="team.teamCode + '-' + team.leadAgentNum"
                    v-for="team in teamTree.teamTree"
                    :key="team.leadAgentNum"
                    @click="
                      queryInfo(team.teamCode + '-' + team.leadAgentNum, 1)
                    "
                    >{{ team.teamName }}</el-menu-item
                  >
                </el-submenu>

                <el-menu-item
                  @click="
                    queryInfo(
                      teamTree.teamCode + '-' + teamTree.leadAgentNum,
                      1
                    )
                  "
                  v-if="teamCode === 'Z'"
                  >{{ teamTree.teamName }}</el-menu-item
                >
              </el-submenu>

              <el-submenu index="2">
                <template slot="title">
                  <!-- <i class="el-icon-location"></i> -->
                  <span>团队考核</span>
                </template>

                <!-- 团队树-->
                <el-submenu
                  :index="teamTree.teamCode + '-' + teamTree.leadAgentNum"
                  v-if="teamCode === 'Q'"
                >
                  <el-menu-item
                    @click="
                      queryInfo(
                        teamTree.teamCode + '-' + teamTree.leadAgentNum,
                        2
                      )
                    "
                    >全部</el-menu-item
                  >
                  <span slot="title">{{ teamTree.teamName }}</span>
                  <el-submenu
                    :index="team.teamCode + '-' + team.leadAgentNum"
                    v-for="team in teamTree.teamTree"
                    :key="team.leadAgentNum"
                  >
                    <el-menu-item
                      @click="
                        queryInfo(team.teamCode + '-' + team.leadAgentNum, 2)
                      "
                      >全部</el-menu-item
                    >
                    <span slot="title">{{ team.teamName }}</span>
                    <el-menu-item
                      :index="team2.teamCode + '-' + team2.leadAgentNum"
                      v-for="team2 in team.teamTree"
                      :key="team2.leadAgentNum"
                      @click="
                        queryInfo(team2.teamCode + '-' + team2.leadAgentNum, 2)
                      "
                      >{{ team2.teamName }}</el-menu-item
                    >
                  </el-submenu>
                </el-submenu>

                <el-submenu
                  :index="teamTree.teamCode + '-' + teamTree.leadAgentNum"
                  v-if="teamCode === 'B'"
                >
                  <el-menu-item
                    @click="
                      queryInfo(
                        teamTree.teamCode + '-' + teamTree.leadAgentNum,
                        2
                      )
                    "
                    >全部</el-menu-item
                  >
                  <span slot="title">{{ teamTree.teamName }}</span>
                  <el-menu-item
                    :index="team.teamCode + '-' + team.leadAgentNum"
                    v-for="team in teamTree.teamTree"
                    :key="team.leadAgentNum"
                    @click="
                      queryInfo(team.teamCode + '-' + team.leadAgentNum, 2)
                    "
                    >{{ team.teamName }}</el-menu-item
                  >
                </el-submenu>

                <el-menu-item
                  @click="
                    queryInfo(
                      teamTree.teamCode + '-' + teamTree.leadAgentNum,
                      2
                    )
                  "
                  v-if="teamCode === 'Z'"
                  >{{ teamTree.teamName }}</el-menu-item
                >
              </el-submenu>

              <el-submenu index="3">
                <template slot="title">
                  <!-- <i class="el-icon-location"></i> -->
                  <span>团队继续率</span>
                </template>

                <!-- 团队树-->
                <el-submenu
                  :index="teamTree.teamCode + '-' + teamTree.leadAgentNum"
                  v-if="teamCode === 'Q'"
                >
                  <el-menu-item
                    @click="
                      queryInfo(
                        teamTree.teamCode + '-' + teamTree.leadAgentNum,
                        3,
                        teamTree.teamName
                      )
                    "
                    >全部</el-menu-item
                  >
                  <span slot="title">{{ teamTree.teamName }}</span>
                  <el-submenu
                    :index="team.teamCode + '-' + team.leadAgentNum"
                    v-for="team in teamTree.teamTree"
                    :key="team.leadAgentNum"
                  >
                    <el-menu-item
                      @click="
                        queryInfo(
                          team.teamCode + '-' + team.leadAgentNum,
                          3,
                          teamTree.teamName
                        )
                      "
                      >全部</el-menu-item
                    >
                    <span slot="title">{{ team.teamName }}</span>
                    <el-menu-item
                      :index="team2.teamCode + '-' + team2.leadAgentNum"
                      v-for="team2 in team.teamTree"
                      :key="team2.leadAgentNum"
                      @click="
                        queryInfo(
                          team2.teamCode + '-' + team2.leadAgentNum,
                          3,
                          teamTree.teamName
                        )
                      "
                      >{{ team2.teamName }}</el-menu-item
                    >
                  </el-submenu>
                </el-submenu>

                <el-submenu
                  :index="teamTree.teamCode + '-' + teamTree.leadAgentNum"
                  v-if="teamCode === 'B'"
                >
                  <el-menu-item
                    @click="
                      queryInfo(
                        teamTree.teamCode + '-' + teamTree.leadAgentNum,
                        3,
                        teamTree.teamName
                      )
                    "
                    >全部</el-menu-item
                  >
                  <span slot="title">{{ teamTree.teamName }}</span>
                  <el-menu-item
                    :index="team.teamCode + '-' + team.leadAgentNum"
                    v-for="team in teamTree.teamTree"
                    :key="team.leadAgentNum"
                    @click="
                      queryInfo(
                        team.teamCode + '-' + team.leadAgentNum,
                        3,
                        teamTree.teamName
                      )
                    "
                    >{{ team.teamName }}</el-menu-item
                  >
                </el-submenu>

                <el-menu-item
                  @click="
                    queryInfo(
                      teamTree.teamCode + '-' + teamTree.leadAgentNum,
                      3,
                      teamTree.teamName
                    )
                  "
                  v-if="teamCode === 'Z'"
                  >{{ teamTree.teamName }}</el-menu-item
                >
              </el-submenu>
            </div>
            <el-menu-item
              index="4"
              @click="performanceReport(4)"
              v-if="showPerformance"
            >
              <template slot="title">业绩报告管理</template>
            </el-menu-item>
            <el-menu-item
              index="5"
              @click="performanceReport(5)"
              v-if="showPerformance"
            >
              <template slot="title">ESG报告管理</template>
            </el-menu-item>
            <el-menu-item
              v-for="(item, index) in teamTwoMenuList"
              :key="index"
              @click="toTeamTwoUrlFunc(item.url,'team')"
            >
              <template slot="title">{{ item.privName }}</template>
            </el-menu-item>
            <!--<el-menu-item index="4">-->
            <!--&lt;!&ndash; <i class="el-icon-setting"></i> &ndash;&gt;-->
            <!--<span slot="title">招募</span>-->
            <!--</el-menu-item>-->
          </el-menu>
        </el-col>
      </el-row>
    </div>
    <!-- 运维 -->
    <div :class="{ 'sale-model': true, operation_hide: operation_hide }">
      <div>
        <h1>销售</h1>
        <div
          class="side_title"
          v-for="(item, index) in consultList"
          :key="index"
        >
          <div
            @click="goConsultList(item.url, index)"
            :class="{ add: isActive === index }"
          >
            {{ item.privName }}
          </div>
          <!-- <div v-if="isClickQ && consultList.length" :class="item.url=='/operationList'?'add':''" class="" @click="goConsultList(item.url)">
                {{item.privName}}
              </div> -->
        </div>
        <!-- <div class="side_title" @click="goOperationList" :class="isClick?'add':''">
              运维
            </div>
            <div class="side_title" @click="goConsult" :class="isClickQ?'addQ':''">
              问题回复
            </div> -->
        <!-- <el-menu
                background-color="rgba(247, 247, 247, 1)"
                router
                default-active="2"
                class="el-menu-vertical-demo"
                text-color="#fff"
                active-text-color="#ffd04b">
              <el-menu-item index="client/consult">
                <span slot="title">客户咨询后台管理</span>
              </el-menu-item>
            </el-menu> -->
      </div>
    </div>
    <div :class="{ 'sale-model': true, message_hide: message_hide }">
      <el-row class="tac">
        <el-col>
          <el-menu
            class="el-menu-vertical-demo"
            @open="handleOpen"
            background-color="#002D76"
            @close="handleClose"
          >
            <h4>咨询</h4>
            <el-submenu index="1">
              <template slot="title">
                <i class="el-icon-location"></i>
                <span>预收统计</span>
              </template>
              <el-menu-item-group>
                <!--<template slot="title">分组一</template>-->
                <el-menu-item index="1-1">选项1</el-menu-item>
                <el-menu-item index="1-2">选项2</el-menu-item>
              </el-menu-item-group>
              <!--<el-menu-item-group title="分组2">-->
              <el-menu-item index="1-3">选项3</el-menu-item>
              <!-- </el-menu-item-group> -->
              <el-submenu index="1-4">
                <template slot="title">选项4</template>
                <el-menu-item index="1-4-1">选项1</el-menu-item>
              </el-submenu>
            </el-submenu>
            <el-menu-item index="2">
              <i class="el-icon-menu"></i>
              <span slot="title">导航二</span>
            </el-menu-item>
            <el-menu-item index="4">
              <i class="el-icon-setting"></i>
              <span slot="title">导航四</span>
            </el-menu-item>
          </el-menu>
        </el-col>
      </el-row>
    </div>
    <div
      class="teamModel"
      :class="{ 'sale-model': true, activity_hide: activity_hide }"
    >
      <ActivitySidebar @go_Activity="go_Activity" :hasRPads="hasRPads"/>
    </div>
    <div :class="{ 'sale-model': true, message_hide: speaking_hide }">
      <SpeakingSidebar @go_Speaking="go_Speaking" :children="childrenMenu" />
    </div>
    <div :class="{ 'sale-model': true, message_hide: recruit_hide}">
      <RecruitSidebar :children="recruitMenuList" @go_Recruit_page="go_Recruit_page"/>
    </div>
  </div>
  <!-- </el-aside>
  </el-container> -->

  <!--</div>-->
</template>

<script>
import api from "@/modules/api.js";
import url from "@/modules/url.js";
import ActivitySidebar from "@/layout/ActivitySidebar";
import SpeakingSidebar from "@/layout/SpeakingSidebar";
import RecruitSidebar from "@/layout/RecruitSidebar";
// 导入n3导航插件
export default {
  //        引入相关模板
  name: "Sidebar",
  components: {
    SpeakingSidebar,
    ActivitySidebar,
    RecruitSidebar,
  },
  //        初始化定义变量
  data() {
    return {
      showExamManage: false,
      showCourseManage: false,
      showActivityManage: false,
      showSpeaking: false,
      showContent: false,
      showConsult: false,
      isLeader: true,
      sidebar_active: "",
      team_hide: true,
      sale_hide: true,
      message_hide: true,
      activity_hide: true,
      speaking_hide: true,
      recruit_hide: true,
      operation_hide: true,
      getTeamTreeReq: {
        agentNum: "",
        level: "",
      },
      teamTree: [],
      activeName: "",
      teamCode: "",
      user: {},
      src: "",
      menuHeight: "",
      childrenMenu: [],
      tbAbout: [],
      XQ: [],
      saleArr: [],
      showOperation: false,
      isClick: false, //点击颜色
      isClickQ: false, //点击问题回复
      consultList: [], //接收路由数组
      isActive: "",
      showPerformance: false,
      ESGadministration: false,
      teamTwoMenuList: [],
      showExamSearch: false,
      recruitMenuList: [],
      showRecruit: false,
      hasRPads: false // 是否续期内勤角色
    };
  },
  /*
   * 在模板渲染成html后调用，
   * 通常是初始化页面完成后，
   * 再对html的dom节点进行一些需要的操作。
   * */
  mounted() {
    this.src = this.$photoUrl;
    this.getUserRoles();
    this.getTeamTree();
    this.init();
    this.setSideBar();
    this.getMenuInfo();
    this.getMenuInfoTwo();
    // this.getTeamTypeAndMember();
    this.getMenuInfoTeam();
    this.getMenuInfoRecruit();

    this.menuHeight = document.querySelector(".menu").clientHeight - 60 + "px";
    // alert(document.querySelector('.menu').clientHeight)
    // document.querySelector('.teamModel').style.height = this.menuHeight
  },
  // 方法集
  methods: {
    // 获取用户角色权限
    getUserRoles () {
      let that = this
      const params = {
        platform: 'PC'
      }
      api.post(url.getUserRoles, params, function (res) {
        const roleArr = new Set(res.data)
        that.hasRPads = roleArr.has('RPADS')   // 续期内勤
      })
    },
    getTeamTypeAndMember() {
      api.post(url.getTeamTypeAndMember, {}, (res) => {
        console.log("resgetTeamTypeAndMember", res);
        if (res.result.isSuccess) {
          this.showPerformance = res.data.isAuthority == "1" ? true : false;
        } else {
          this.$message({
            type: "error",
            message: res.result.error,
          });
        }
      });
    },
    performanceReport(index) {
      console.log(index);
      if (index === 4) {
        this.$router.push({
          name: "performanceReportManagement",
        });
        this.team_hide = true;
      } else if (index === 5) {
        this.$router.push({
          name: "ESGadministration",
        });
        this.team_hide = true;
      }
    },
    toTeamTwoUrlFunc(url, activeSidebar) {
      this.team_hide = true;
      this.sidebar_active = activeSidebar;

      if (url === "") {
        this.$message("敬请期待");
      } else if (url.startsWith('http')) {
        window.location.href = url;
      } else if (url.startsWith('/')) {
        this.$router.push({ path: url });
      } else {
        this.$router.push({ path: '/' + url });
      }
    },
    getMenuInfo() {
      let submitInfo = {
        pid: "38514a2c49aa441ebdbf51bddbd53dce",
      };
      let that = this;
      // 调用接口保存告知数据
      api.getMenuInfo(submitInfo, (res) => {
        console.log(res, "123");
        if (res.result.isSuccess) {
          let param = res.data.menus.children;
          if (param != null && param.length > 0) {
            console.log(param, "接口返回得权限--------------");
            param.forEach((element) => {
              if (element.privName == "内容管理") {
                this.showContent = true;
              }
              if (element.privName == "考试管理") {
                this.showExamManage = true;
              }
              if (element.privName == "考试查询人员") {
                this.showExamSearch = true;
              }
              if (element.privName == "培训管理") {
                this.showCourseManage = true;
              }
              if (element.privName == "活动量管理") {
                this.showActivityManage = true;
              }
              if (element.privName == "创说会") {
                this.showSpeaking = true;
                this.childrenMenu = element.children;
              }
              if (element.privName == "客服咨询") {
                this.showConsult = true;
                this.consultList = element.children;
                console.log(this.consultList, "consultList");
              }
            });
          }
        } else {
          that.$message.error(res.result.error);
        }
      });
    },
    getMenuInfoTwo() {
      // 查询二级菜单权限
      let submitInfo = {
        pid: "32807194ec8b4ac794e2c7e2c01d4259",
      };
      let that = this;
      // 调用接口保存告知数据
      api.getMenuInfo(submitInfo, (res) => {
        if (res.result.isSuccess === true) {
          if (
            res.data.menus.children != null &&
            res.data.menus.children.length > 0
          ) {
            let temp = res.data.menus.children;
            this.saleArr = res.data.menus.children;
            temp.forEach((i) => {
              if (
                trim(i.privName) == "投保相关" ||
                trim(i.privName) == "建议书与投保" ||
                i.privName.includes("首期")
              ) {
                console.log("trim(i.privName)", trim(i.privName));
                let obj = {};
                let tempTB = i.children.reduce((cell, next) => {
                  obj[next.privName]
                    ? ""
                    : (obj[next.privName] = true && cell.push(next));
                  return cell;
                }, []);
                tempTB.forEach((j) => {
                  if (j.url.includes("https")) {
                    that.tbAbout.push(j);
                  }
                });
              }
              if (trim(i.privName) == "续期") {
                let tempTB = i.children;
                tempTB.forEach((j) => {
                  if (trim(j.privName) == "个人继续率") that.XQ.push(j);
                });
              }
            });
            console.log(that.tbAbout, "投保相关=====");
          } else {
            // that.nonestatus = true
          }
        } else {
          that.$message(res.result.error);
        }
      });
    },
    getMenuInfoTeam() {
      let submitInfo = {
        pid: "3091e8d0b6dc442184e99d8479328bbd",
      };
      let that = this;
      // 调用接口保存告知数据
      api.getMenuInfo(submitInfo, res => {
        if (res.result.isSuccess) {
          this.teamTwoMenuList = res.data.menus.children
        } else {
          that.$message.error(res.result.error);
        }
      });
    },
    getMenuInfoRecruit(){
      let submitInfo = {
        pid: "f43bb8701a1540239deb603792d65b55",
      }
      api.getMenuInfo(submitInfo, (res) => {
        if (res.result.isSuccess) {
          let menuLists = res.data.menus.children;
          if(menuLists.length > 0){
            this.recruitMenuList = menuLists
            this.showRecruit = true;
          }
        } else {
          that.$message.error(res.result.error);
        }
      });
    },
    // 招募跳转
    go_Recruit_page(url){
      this.navigateToUrl(url, 'recruit')
    },
    navigateToUrl(url, activeSidebar) {
      this.team_hide = true;
      this.recruit_hide = true;
      this.sidebar_active = activeSidebar;

      if (url === "") {
        this.$message("敬请期待");
      } else if (url.startsWith('http')) {
        window.location.href = url;
      } else if (url.startsWith('/')) {
        this.$router.push({ path: url });
      } else {
        this.$router.push({ path: '/' + url });
      }
    },
    setSideBar() {
      let sidebarName = window.sessionStorage.getItem("sidebar_active");
      if (sidebarName) {
        this.sidebar_active = sidebarName;
      } else {
        this.sidebar_active = "home";
      }
    },
    init() {
      let that = this;
      api.post(url.getPuserInfo, {}, function (res) {
        that.user = res.data;
        // 埋点
        if (that.user.accType == "AGENT") {
          that.getTeamTypeAndMember();
          // 营销员  调用queryagentinfo接回数据
          api.post(url.getQueryAgentInfo, {}, function (data) {
            zhuge.identify(data.data.agent_id, {
              userId: data.data.agent_id, //用户id
              userName: data.data.agent_name, //姓名
              channelType: data.data.channel_id, //渠道
              acctype: data.data.role, //角色
              team: data.data.company, // 所属分公司
              teamThree: data.data.organ_id, // 所属三级机构
              teamFour: data.data.aracde, //所属四级机构
            });
          });
        } else {
          // 非营销员 用getUserBaseInfo接回数据
          zhuge.identify(that.user.pId, {
            userId: that.user.pId, //用户id
            userName: that.user.psnName, //姓名
            acctype: that.user.accType, //角色
          });
        }
        zhuge.track("login", {
          viewTime: that.moment(new Date()).format("YYYY/MM/DD hh:mm:ss"), //进入时间
        });
        console.log(that.user, "2222");
        window.sessionStorage.setItem("name", that.user.psnName);
        window.sessionStorage.setItem("channelType", that.user.channel);
        if (that.user.sexName === "女") {
          that.src = that.src + "salm-" + that.user.pId + ".jpg";
        } else {
          that.src = that.src + "sal-" + that.user.pId + ".jpg";
        }
        that.isLeader = that.user.memberType;
      });
    },
    go_person() {
      //alert('敬请期待');
      //return false;
      this.sidebar_active = "person";
      // 跳转
      this.$router.push({
        path: "/home/user",
        params: { src: this.src, username: this.user.psnName },
      });
      // 弹出框的现实与隐藏
      this.sale_hide = true;
      this.message_hide = true;
      this.team_hide = true;
      this.activity_hide = true;
      this.speaking_hide = true;
      this.recruit_hide = true;
      this.operation_hide = true;
    },
    go_home() {
      this.sidebar_active = "home";
      this.$router.push({ path: "/home/index" });
      this.sale_hide = true;
      this.message_hide = true;
      this.team_hide = true;
      this.activity_hide = true;
      this.speaking_hide = true;
      this.recruit_hide = true;
      this.operation_hide = true;
    },
    go_sale(event) {
      if (this.sale_hide) {
        this.sale_hide = false;
        this.sidebar_active = "sale";
      } else {
        this.sale_hide = true;
        // this.sidebar_active = ''
      }
      this.team_hide = true;
      this.message_hide = true;
      this.activity_hide = true;
      this.speaking_hide = true;
      this.recruit_hide = true;
      this.operation_hide = true;
    },
    go_team() {
      // this.sidebar_active = 'team'
      // this.$router.push({path: '/test3'})
      // this.sale_hide = true
      // this.message_hide = true
      // this.team_hide = true

      if (this.team_hide) {
        this.team_hide = false;
        this.sidebar_active = "team";
        // this.$router.push({path: '/teamAssess'})
      } else {
        this.team_hide = true;
        // this.sidebar_active = ''
      }
      this.message_hide = true;
      this.sale_hide = true;
      this.activity_hide = true;
      this.speaking_hide = true;
      this.recruit_hide = true;
    },
    go_operation() {
      if (this.operation_hide) {
        this.operation_hide = false;
        this.sidebar_active = "operation";
      } else {
        this.operation_hide = true;
      }
      this.team_hide = true;
      this.sale_hide = true;
      this.message_hide = true;
      this.activity_hide = true;
      this.speaking_hide = true;
      this.recruit_hide = true;
    },
    go_message() {
      this.sidebar_active = "message";
      this.$router.push({ path: "/home/message" });
      this.sale_hide = true;
      this.message_hide = true;
      this.team_hide = true;
      this.activity_hide = true;
      this.speaking_hide = true;
      this.recruit_hide = true;
      this.operation_hide = true;
    },
    toURLParameter(url) {
      let that = this;
      // alert('url是'+url)
      that.sale_hide = true;
      that.sidebar_active = "sale";
      if (url === "") {
        that.$message("敬请期待");
      } else if (url.slice(0, 4) === "http") {
        // that.$app.Jump.jumpView(url)
        window.location.href = url;
      } else if (url.slice(0, 1) === "/") {
        that.$router.push({ path: url });
      } else {
        that.$router.push({ path: "/" + url });
      }
    },
    // handleSelect(key, keyPath) {
    //   this.sale_hide = true
    //   this.sidebar_active = 'sale'
    //   console.log(key, keyPath)
    //   if(key === 'proposal'){
    //      window.location.href = 'http://localhost/#/proposal/list'
    //     }else if(key === 'eleinsure'){
    //       window.location.href = 'http://localhost/#/eleinsure/list'
    //     }else{
    //       window.location.href = 'http://localhost/#/custom/index'
    //     }
    // },
    go_content() {
      this.sidebar_active = "content";
      this.$router.push({ path: "/home/getContents" });
      this.sale_hide = true;
      this.message_hide = true;
      this.team_hide = true;
      this.activity_hide = true;
      this.speaking_hide = true;
      this.recruit_hide = true;
      this.operation_hide = true;
    },
    //考试后台
    go_examManage() {
      this.sidebar_active = "content";
      this.$router.push({ path: "/manage/paperDetails" });
      this.sale_hide = true;
      this.message_hide = true;
      this.team_hide = true;
      this.activity_hide = true;
      this.speaking_hide = true;
      this.recruit_hide = true;
      this.operation_hide = true;
    },
    go_examManage2() {
      this.sidebar_active = "content";
      this.$router.push({ path: "/examSearch/paperDetails" });
      this.sale_hide = true;
      this.message_hide = true;
      this.team_hide = true;
      this.activity_hide = true;
      this.speaking_hide = true;
      this.recruit_hide = true;
      this.operation_hide = true;
    },
    //培训后台
    go_training() {
      this.sidebar_active = "training";
      this.$router.push({ path: "/backendHome/readInfoList" });
      this.sale_hide = true;
      this.message_hide = true;
      this.team_hide = true;
      this.activity_hide = true;
      this.speaking_hide = true;
      this.recruit_hide = true;
      this.operation_hide = true;
    },
    go_Activity() {
      // this.sidebar_active = 'Activity'
      this.sale_hide = true;
      this.message_hide = true;
      this.team_hide = true;
      this.operation_hide = true;
      if (this.activity_hide) {
        this.activity_hide = false;
        this.sidebar_active = "Activity";
      } else {
        this.activity_hide = true;
        // this.sidebar_active = ''
      }
      this.speaking_hide = true;
      this.recruit_hide = true;
      // this.$router.push({ path: '/home/Activitycount' })
    },
    go_Recruit() {
      this.speaking_hide = true;
      this.operation_hide = true;
      this.sidebar_active = "recruit";
      this.message_hide = true;
      this.sale_hide = true;
      this.activity_hide = true;
      if (this.recruit_hide) {
        this.recruit_hide = false;
      } else {
        this.recruit_hide = true;
      }
    },
    go_Speaking() {
      this.operation_hide = true;
      this.sidebar_active = "speaking";
      // this.$router.push({ path: '/home/speaking' });
      this.message_hide = true;
      this.sale_hide = true;
      this.recruit_hide = true;
      this.activity_hide = true;
      if (this.speaking_hide) {
        this.speaking_hide = false;
      } else {
        this.speaking_hide = true;
      }
    },
    // 获取团队树
    getTeamTree() {
      var that = this;
      api.getTeamTree(this.getTeamTreeReq, function (res) {
        console.log(res.data.data);
        that.teamTree = res.data.data;
        that.teamCode = res.data.data.teamCode.substring(0, 1);
        console.log(that.teamCode);
      });
    },
    handleOpen(key, keyPath) {
      // key:当前点击菜单index
      // keyPath: 当前点击菜单及其父菜单的级联index
      // 判断是第几个 团队树
      // var ins = keyPath[0]
      // var route = ''
      // if (ins === '1') {
      //   route = 'teamInfo'
      // } else if (ins === '2') {
      //   route = 'teamAssess'
      // } else if (ins === '3') {
      //   route = 'teamConRate'
      // }
      // var info = key
      // var teamCode = info.substring(0, info.indexOf('-'))
      // var agentNum = info.substring(info.indexOf('-') + 1)
      // this.$router.push({name: route, query: {pid: agentNum, teamCode: teamCode}})
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath)
    },
    queryInfo(index, ins, name) {
      console.log(index, ins, name);
      let route = "";
      if (ins === 1) {
        route = "teamInfo";
      } else if (ins === 2) {
        route = "teamAssess";
      } else if (ins === 3) {
        route = "teamConRate";
      } else if (ins === 4) {
        route = "performanceReportManagement";
      }
      var info = index;
      var teamCode = info.substring(0, info.indexOf("-"));
      var agentNum = info.substring(info.indexOf("-") + 1);
      this.$router.push({
        name: route,
        params: { pid: agentNum, teamCode: teamCode, name: name },
      });
      this.go_team();
    },
    setSidebar_active() {
      window.sessionStorage.setItem("sidebar_active", this.sidebar_active);
    },
    goConsultList(item, index) {
      // console.log(index,'index')
      // if(item=='/operationList'){
      //   this.isClick = true
      //   this.isClickQ = true
      // }else{
      //   this.isClick = false
      //   this.isClickQ = false
      // }
      this.isActive = index;
      this.$router.push({
        path: item,
      });
    },
    // goConsult(){
    //   this.isClick = false
    //   this.isClickQ = true
    //   this.$router.push({
    //     path:'/client/consult'
    //   })
    //   this.operation_hide = true
    // },
    // goOperationList(){
    //   this.isClick = true
    //   this.isClickQ = false
    //   this.$router.push({
    //     path:'/operationList'
    //   })
    //   this.operation_hide = true
    // },
    //团队继续率
    // goTeamRate(){
    //   this.$router.push({
    //     path:'/teamRate'
    //   })
    // }
  },
  //        实时监控路由改变就执行
  watch: {
    $route: "setSidebar_active",
  },
};
</script>

<style scoped>
.router-link-exact-active .itemleftq {
  background: #5b9fec;
}
.sale-model .router-link-exact-active .item {
  color: #5b9fec;
}
.dotItem {
  border-bottom: 1px solid #eee;
  padding: 16px 0;
}
.itemleftq {
  width: 9px;
  height: 9px;
  background: rgba(210, 210, 210, 1);
  border-radius: 50%;
  margin-right: 9.5px;
  margin-left: 40px;
}
.sale-model div.iteminline {
  display: inline-block;
  color: #999;
  cursor: pointer;
}
.menu {
  /* min-height: calc(100% - 70px); */
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  min-height: 100%;
  height: 100%;
  padding-top: 60px;
  border: none;
  background: #194793;
  /* position: fixed;
  top: 0;
  left: 0; */
  width: 100%;
  /*box-shadow: 1px 1px 5px 1px rgba(1, 1, 1, 0.3);*/
  color: #a2bbe1;
  z-index: 1000;
  position: relative;
}

/* .menu-item{
    text-align: center;
    padding:20px 0;
  }
  .menu-item img{
    width: 100%
  } */
.team_hide,
.sale_hide,
.message_hide,
.activity_hide,
.speaking_hide,
.operation_hide {
  display: none;
}
.photo {
  width: 50px;
  height: 50px;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 50%;
  /* border:2px solid #cacaca; */
}
.menuphoto.active {
  color: #194793;
}
/* .menuphoto.active .photo{border:2px solid #194793;} */
.photo img {
  /* width: 50px;
    height: 50px; */
  width: 100%;
}
.photo-div {
  width: 100%;
  text-align: center;
  overflow: hidden;
  padding: 10px 0;
  cursor: pointer;
}
.usernametxt {
  margin-top: 5px;
}
.title-detail {
  font-size: 12px;
  margin-top: 2px;
}
.blue .active {
  background-color: #002d76;
}
.active {
  background-color: #f5f6fa;
  width: 101%;
}
.sale-model {
  background: rgba(247, 247, 247, 1);
  box-shadow: 3px 0px 5px 0px rgba(162, 187, 225, 0.3);
  /* height:100%; */
  height: calc(100% - 60px);
  min-width: 200px;
  position: absolute;
  top: 60px;
  /* left: 100%; */
  left: 110px;
  z-index: 999;
}
.menu-item {
  text-align: center;
  padding: 15px 0;
  cursor: pointer;
}
/*.menu-item img {
  width: 35%;
  max-width: 26px;
}
 .sidebar1 img{
  width: 40%;
  max-width: 32px;
  } */
.icon {
  width: 100%;
  height: 36px;
}
.sidebar1 .icon {
  background: url(../../static/image/sidebar-home.png) no-repeat center;
  background-size: 28px 28px;
}
.sidebar1.active .icon {
  background: url(../../static/image/home_on.png) no-repeat center;
  background-size: 28px 28px;
}
.sidebar2 .icon {
  background: url(../../static/image/sidebar-sale.png) no-repeat center;
  background-size: 26px 28px;
}
.sidebar2.active .icon {
  background: url(../../static/image/sale_on.png) no-repeat center;
  background-size: 26px 28px;
}
.sidebar3 .icon {
  background: url(../../static/image/sidebar-team.png) no-repeat center;
  background-size: 28px 29px;
}
.sidebar3.active .icon {
  background: url(../../static/image/team_on.png) no-repeat center;
  background-size: 28px 29px;
}
.sidebar34 .icon {
  background: url(../../static/image/sidebar_consult.png) no-repeat center;
  background-size: 28px 29px;
}
.sidebar34.active .icon {
  background: url(../../static/image/consult_on.png) no-repeat center;
  background-size: 28px 29px;
}
.sidebar4 .icon {
  background: url(../../static/image/sidebar-message.png) no-repeat center;
  background-size: 25px 29px;
}
.sidebar4.active .icon {
  background: url(../../static/image/message_on.png) no-repeat center;
  background-size: 25px 29px;
}
.sidebar5 .icon {
  background: url(../../static/image/sidebar-content.png) no-repeat center;
  background-size: 29px 29px;
}
.sidebar5.active .icon {
  background: url(../../static/image/content_on.png) no-repeat center;
  background-size: 29px 29px;
}
.sidebarcom.active .txt {
  color: #194793;
}
.sidebar6 .icon {
  background: url(../../static/image/sidebar-exam.png) no-repeat center;
  background-size: 32px 32px;
}
.sidebar6.active .icon {
  background: url(../../static/image/sidebar-exam.png) no-repeat center;
  background-size: 32px 32px;
}
.sidebar7 .icon {
  background: url(../../static/image/sidebar-training.png) no-repeat center;
  background-size: 32px;
}
.sidebar7.active .icon {
  background: url(../../static/image/sidebar-training.png) no-repeat center;
  background-size: 32px;
}
.sidebar8 .icon {
  background: url(../../static/image/sidebar-activity.png) no-repeat center;
  background-size: 32px;
}
.sidebar8.active .icon {
  background: url(../../static/image/activity-on.png) no-repeat center;
  background-size: 32px;
}
.sidebar9 .icon {
  background: url(../../static/image/sidebar-chuang.png) no-repeat center;
  background-size: 32px;
}
.sidebar9.active .icon {
  background: url(../../static/image/sidebar-chuang-on.png) no-repeat center;
  background-size: 32px;
}
.sidebar10 .icon {
  background: url(../../static/image/sidebar-recruit.png) no-repeat center;
  background-size: 32px;
}
.sidebar10.active .icon {
  background: url(../../static/image/sidebar-recruit-on.png) no-repeat center;
  background-size: 32px;
}
.sale-model span,
.sale-model li,
.sale-model div {
  color: #5876b9;
}

.sale-model h4 {
  text-align: center;
}
.sale-model ul {
  border: none;
}
.sale-model h1 {
  text-align: center;
  font-size: 18px;
  color: rgba(153, 153, 153, 1);
  height: 100px;
  line-height: 100px;
  padding: 0;
  margin: 0;
  font-weight: normal;
}
.sale-model >>> .el-collapse-item__header {
  background: transparent;
  border-bottom: 1px solid #e5e5e5;
}
.sale-model >>> .el-collapse-item__header:hover {
  background-color: #5b9fec;
  color: #fff;
}
.sale-model >>> .el-collapse-item__header.is-active {
  background: #5b9fec;
  color: #fff;
}
.sale-model >>> .el-collapse-item__header:hover .el-icon-arrow-right:before {
  color: #fff;
}
.sale-model
  >>> .el-collapse-item__header.is-active
  .el-icon-arrow-right:before {
  color: #fff;
}
.routerlink:hover .itemleftq {
  background: #5b9fec;
}
.routerlink:hover .item {
  color: #5b9fec;
}
.sale-model >>> .el-collapse-item__content {
  padding-top: 20px;
  padding-bottom: 20px;
}
.sale-model >>> .el-collapse-item__wrap {
  background: transparent;
}

.saleModel >>> .el-menu {
  background: transparent;
}
.saleModel >>> .el-menu-item:hover {
  background: #5b9fec;
  color: #fff;
}
.saleModel >>> .el-menu-item:hover .el-icon-location:before {
  color: #fff;
}
.saleModel >>> .el-menu-item:hover span {
  color: #fff;
}
.saleModel >>> .el-menu-item:hover i {
  color: #fff;
}
.saleModel >>> .el-menu-item:focus,
.el-menu-item:hover {
  background: transparent;
  color: #999;
}
.saleModel >>> .el-submenu__title {
  border-top: 1px solid #e5e5e5;
  height: 58px;
  line-height: 58px;
}
.saleModel >>> .el-menu-item {
  border-top: 1px solid #e5e5e5;
  padding-left: 20% !important;
}
.saleModel >>> .el-collapse {
  border-bottom: 0;
}

/* .saleModel span{ color: #999;} */
.sale-model >>> .tbAbout .el-collapse-item__content {
  padding-top: 0;
  padding-bottom: 0;
}
/* .coll-item{

} */
.tac {
  height: 95%;
  overflow-x: hidden;
  overflow-y: auto;
}

.tac >>> .el-collapse-item__header {
  height: 58px;
  line-height: 58px;
  color: #5876b9;
  padding-left: 20%;
}
.tac >>> .el-collapse-item__arrow {
  line-height: 58px;
  color: #5876b9;
  /* margin-right:20px; */
}
.item {
  height: 23px;
  line-height: 23px;
  text-decoration: none;
}
.teamModel >>> .el-menu {
  background: transparent;
}
.teamModel >>> .el-submenu__title:hover {
  background: #5b9fec;
  color: #fff;
}
.teamModel >>> .el-submenu__title:hover .el-icon-location:before {
  color: #fff;
}
.teamModel >>> .el-submenu__title:hover span {
  color: #fff;
}
.teamModel >>> .el-submenu__title:hover i {
  color: #fff;
}
.teamModel >>> .el-submenu.is-opened .el-submenu__title {
  background: #5b9fec;
  color: #fff;
}
.teamModel >>> .el-submenu.is-opened .el-submenu__title span {
  color: #fff;
}
.teamModel >>> .el-submenu.is-opened ul li .el-submenu__title {
  background: rgba(247, 247, 247, 1);
}
.teamModel >>> .el-submenu.is-opened .el-icon-location:before {
  color: #fff;
}
.teamModel >>> .el-submenu.is-opened ul li .el-submenu__title span {
  color: #999;
}
.teamModel >>> .el-submenu.is-opened ul li .el-submenu__title span:hover {
  color: #5876b9;
}
.teamModel >>> .el-submenu.is-opened i {
  color: #fff;
}
.teamModel >>> .el-submenu.is-opened ul li i {
  color: #999;
}
.teamModel >>> .el-submenu.is-opened .el-menu-item {
  color: #999;
}
.teamModel >>> .el-submenu.is-opened .el-menu-item:hover {
  color: #5876b9;
}
.teamModel >>> .el-menu-item:focus,
.el-menu-item:hover {
  background: transparent;
}
.teamModel >>> .el-submenu__title {
  border-top: 1px solid #e5e5e5;
  height: 58px;
  line-height: 58px;
}
.teamModel >>> .el-menu-item {
  border-top: 1px solid #e5e5e5;
}
/* .teamModel >>> .el-submenu__title{padding-left: 20% !important;} */

@media screen and (max-width: 1024px) {
  /* .menu {
    font-size: 14px;
    padding-top: 50px;
  } */
  .title-detail {
    font-size: 12px;
  }
  /* .sale-model {
    top: 50px;
    height: calc(100% - 50px);
  } */
}
@media screen and (min-width: 1400px) {
  /* .menu-item {
    padding: 15px 0;
  } */
  /* .menu {
    width: 5%;
  } */
}
/* @media screen and (min-width: 1024px) and (max-width: 1400px) {
    .menu-item {
      padding: 15px 0;
    }
  } */
.side_title {
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
}
.side_title:hover {
  cursor: pointer;
  /* background: #5876b9;
    color:#fff; */
}
.add {
  background: #5876b9;
  color: #fff !important;
}
/* .addQ{
    background: #5876b9;
    color:#fff!important;
  }  */
.teamShow {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/layout/Sidebar.vue